<template>
  <Modal @close="$emit('close')" :classes="'col-md-4'" :title="modalTitle">
    <div slot="body">
      <div class="container mb-3 custom-scroll">
        <template v-if="prevAssignBook">
          <p class="text-justify">
            {{ data.bookAbstract }}
          </p>
        </template>
        <template v-else>
          <div class="row">
            <div class="col">
              <DropSelect
                v-bind="selectCourse"
                :zIndex="3"
                v-model="selectCourse.selected"
              />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <VueDatePicker
                v-model="initialDate"
                :color="secCol"
                v-if="selectCourse.selected"
                :noHeader="true"
                :maxDate="maxDate"
                :minDate="minDate"
              >
                <template #activator="{ date }">
                  <DropSelect
                    :date="date"
                    :type="'datePicker'"
                    :supTitle="'Fecha inicial'"
                    :placeholder="'Seleccione el día'"
                    :icon="'schedule'"
                    :inline="false"
                    :zIndex="2"
                  />
                </template>
              </VueDatePicker>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <VueDatePicker
                v-model="endDate"
                :color="secCol"
                v-if="initialDate"
                :noHeader="true"
                :maxDate="maxDate"
                :minDate="minDate"
              >
                <template #activator="{ date }">
                  <DropSelect
                    :date="date"
                    :type="'datePicker'"
                    :supTitle="'Fecha final'"
                    :placeholder="'Seleccione el día'"
                    :icon="'schedule'"
                  />
                </template>
              </VueDatePicker>
            </div>
          </div>
        </template>
      </div>
      <div class="row align-items-end">
        <div class="col-12 text-center d-flex justify-content-around">
          <template v-if="prevAssignBook">
            <router-link class="button primary" :to="`/read-book/${bookId}`">
              Previsualizar libro
            </router-link>
            <button class="button" @click="prevAssignBook = false">
              Asignar libro
            </button>
          </template>
          <template v-else>
            <button
              v-if="!isMaintainer"
              class="button primary"
              @click="prevAssignBook = true"
            >
              Volver
            </button>
            <button
              class="button"
              :class="{
                gray: !initialDate || !endDate,
                logo: initialDate && endDate,
              }"
              @click="setBookDate"
            >
              Aceptar
            </button>
          </template>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import Modal from "@/components/Modal";
import DropSelect from "@/components/DropSelect";

export default {
  name: "BookModal",
  components: {
    Modal,
    DropSelect,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      prevAssignBook: !this.isMaintainer,
      modalTitle: "",
      secCol,
      initialDate: null,
      endDate: null,
      courseId: null,
      bookId: null,
      selectCourse: {
        options: [],
        selected: undefined,
        placeholder: "Seleccione Curso o Sección",
        supTitle: "Curso o Sección",
        id: "curso",
        icon: "graduation-hat",
        valueKey: "id",
        textKey: "name",
      },
    };
  },
  props: ["data", "isMaintainer", "assignationData"],
  computed: {
    ...mapState(["userData", "dataUrl", "teacherData", "courseList"]),
  },
  methods: {
    validateDates(newVal, oldVal, dateType) {
      if (!newVal || newVal == oldVal) return;
      let valid = true;
      let initialDate;
      let endDate;

      switch (dateType) {
        case "initialDate":
          if (!this.endDate) return;

          initialDate = new Date(newVal);
          endDate = new Date(this.endDate);

          if (endDate <= initialDate) {
            this.$notify({
              title: [
                "Fecha incorrecta",
                "La fecha inicial no puede ser mayor a la fecha final",
              ],
              type: "danger",
            });

            valid = false;
          }
          break;

        case "endDate":
          if (!this.initialDate) return;

          initialDate = new Date(this.initialDate);
          endDate = new Date(newVal);

          if (endDate <= initialDate) {
            this.$notify({
              title: [
                "Fecha incorrecta",
                "La fecha final no puede ser menor a la fecha inicial",
              ],
              type: "danger",
            });

            valid = false;
          }
          break;
      }

      if (valid) {
        this[dateType] = newVal;
      } else {
        this[dateType] = oldVal;
      }
    },
    async setBookDate() {
      if (!this.initialDate || !this.endDate) return;

      let apiData;
      if (this.isMaintainer) {
        apiData = {
          id: this.assignationData.id,
          course: {
            id: this.selectCourse.selected,
          },
          book: {
            id: this.bookId,
          },
          evaluationDate: this.endDate,
          startingDate: this.initialDate,
          existSuggestedEvaluation: this.assignationData
            .existSuggestedEvaluation,
          teacherEvaluation: this.assignationData.teacherEvaluation,
        };
      } else {
        apiData = {
          id: "",
          course: {
            id: this.selectCourse.selected,
          },
          book: {
            id: this.bookId,
          },
          evaluationDate: this.endDate,
          startingDate: this.initialDate,
          existSuggestedEvaluation: "false",
          teacherEvaluation: "IN_PROCESS",
        };
      }

      let apiUrl = `${this.dataUrl}/courseBook/${
        this.isMaintainer ? "updateCourseBook" : "addCourseBook"
      }`;
      let loader = this.$loading.show();
      const method = this.isMaintainer ? "put" : "post";

      try {
        let { data } = await this.axios[method](apiUrl, apiData);
        let msg = "";
        if (data.status.name.toLocaleLowerCase() == "error") msg = data.content;

        if (data.content == true) {
          if (this.isMaintainer) this.$emit("updateBook", apiData);
          this.$notify({
            title: [
              this.isMaintainer ? "Edición exitosa" : "Asignación exitosa",
            ],
            type: "success",
          });
          this.$emit("close");
        } else {
          this.$notify({
            title: ["Ocurrio un error", msg],
            type: "danger",
          });
        }
      } catch (e) {
        let msg = "";
        if (e.status.name.toLocaleLowerCase() == "error") msg = e.content;

        this.$notify({
          title: ["Ocurrio un error", msg],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
    getCourses() {
      this.selectCourse.options = this.courseList;
    },
  },
  watch: {
    assignationData: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.selectCourse.selected = newValue.course.id;
          this.initialDate = newValue.startingDate;
          this.endDate = newValue.evaluationDate;
        }
      },
    },
    initialDate(newVal, oldVal) {
      this.validateDates(newVal, oldVal, "initialDate");
    },
    endDate(newVal, oldVal) {
      this.validateDates(newVal, oldVal, "endDate");
    },
    prevAssignBook: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.modalTitle = this.data.title;
        } else {
          this.modalTitle = this.isMaintainer
            ? "Edite asignación"
            : "Asignación de libro del mes";
        }
      },
    },
  },
  mounted() {
    this.bookId = this.data.id;
    this.getCourses();
  },
  created() {
    // Mínima y máxima fecha para asignación por mes
    this.minDate = this.$moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.maxDate = this.$moment()
      .endOf("month")
      .format("YYYY-MM-DD");
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-height: 50vh;
  overflow: auto;
  height: 30vh;
}
</style>
